<template>
    <div class="group">
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import store from '../../store.js';

export default {
  data () {
    return { };
  },
  
  watch: {
    '$route': 'beforeRouteEnter', // call this method if the route changes
  },
    
  beforeRouteEnter (to, from, next) {
    next();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/role/Role.vue